import React from 'react';
import { withRouter, NavLink } from 'react-router-dom';
import 'styles/css/nvabar.scss';
import { inject, observer } from 'mobx-react';

@withRouter
@inject('user')
@inject('SponsorStore')
@observer
export default class SponsorNav extends React.Component {
  state = {
    activeTab: null
  };

  triggerPopup = ({pathname}) => {
    if (this.props.user.user.governing_body === 'iacp' && pathname === '/') {
      this.props.alert.success(`You are now leaving the IACP members area.
      To return please click on the 'IACP Members Area' button
      at the top of the Therapy Academy homepage.`, 5000);
    } else if (this.props.user.user.governing_body === 'aci' && pathname === '/') {
      this.props.alert.success(`You are now leaving the ACI members area.
      To return please click on the 'ACI Members Area' button
      at the top of the Therapy Academy homepage.`, 5000);
    }
  }
  render() {
    const sponsorUrl = this.props.SponsorStore.sponsorId;
    return (
      <nav
        className="bottom-header row spons-nav"
        style={{ display: this.state.display }}
      >
        <div className="bottom-header-inner">
          <NavLink to={`/${sponsorUrl}`} exact
                  className="col bottom-header-content" 
                  activeClassName="selected"
          >
            workshops
          </NavLink>

          <NavLink to={`/${sponsorUrl}/purchased`}
                  className="col bottom-header-content"
                  activeClassName="selected"
          >
            MY PURCHASES
          </NavLink>

          <NavLink to={`/${sponsorUrl}/in_progress`}
                  className="col bottom-header-content"
                  activeClassName="selected"
          >
            in progress
          </NavLink>

          <NavLink to={`/${sponsorUrl}/completed`} 
                  className="col bottom-header-content" 
                  activeClassName="selected"
          >
            completed
          </NavLink>

          {//<NavLink to={`/`}
           //       className="col bottom-header-content"
           //       onClick={this.triggerPopup}
          //>
           // Other Workshops
          //</NavLink>
        }

        </div>
      </nav>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/SponsorNav.jsx